export const styles = {
  card: { padding: '2.5rem', marginBottom: '2rem' },
  buttonsWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  title: {
    marginTop: '1rem',
    marginBottom: '2rem',
  },
  input: {
    marginBottom: '2rem',
  },
}



// WEBPACK FOOTER //
// ./src/Containers/Settings/TagsManagement/TagsManagementForm/styles.js